module.exports = "/_next/static/images/c6147fa95dc8207f3e552a3ebba259a9-mockup-transfer@1x.jpg.webp";